import { useTranslation } from 'react-i18next';
import Constants from 'style/constants';
import MonitoringFilter from 'shared/components/monitoring/monitoring-filter/monitoring-filter';
import { MonitoringType } from 'shared/components/monitoring/monitoring-type';

import { useConnectorsContextProvider } from 'features/connectors/context/connectors-provider';

const Offline = () => {
  const { t } = useTranslation('monitoring');
  const { connectorsFilterHook } = useConnectorsContextProvider();

  return (
    <MonitoringFilter
      text={t('filter.connectorOffline')}
      type={MonitoringType.ConnectorOffline}
      countColor={Constants.Colors.error}
      count={connectorsFilterHook.getMonitorFilter(MonitoringType.ConnectorOffline).count}
      isSelected={connectorsFilterHook.isActiveMonitorFilter(MonitoringType.ConnectorOffline)}
      onSelected={(selected) => {
        connectorsFilterHook.selectMonitorFilter(MonitoringType.ConnectorOffline, selected);
      }}
    />
  );
};

const Online = () => {
  const { t } = useTranslation('monitoring');
  const { connectorsFilterHook } = useConnectorsContextProvider();

  return (
    <MonitoringFilter
      text={t('filter.connectorOnline')}
      type={MonitoringType.ConnectorOnline}
      countColor={Constants.Colors.success}
      count={connectorsFilterHook.getMonitorFilter(MonitoringType.ConnectorOnline).count}
      isSelected={connectorsFilterHook.isActiveMonitorFilter(MonitoringType.ConnectorOnline)}
      onSelected={(selected) => {
        connectorsFilterHook.selectMonitorFilter(MonitoringType.ConnectorOnline, selected);
      }}
    />
  );
};

const ConnectorMonitoringFilter = {
  Offline: Offline,
  Online: Online,
};

export default ConnectorMonitoringFilter;
